<template>
  <v-app>
    <router-view />
    <notification></notification>
    <OverlayLoading></OverlayLoading>
  </v-app>
</template>

<script>
import { SET_NOTIFICATION } from "@/store/mutations.type";
import i18n from "@/plugins/i18n";
import Notification from "@/layout/Notification";
import OverlayLoading from "@/layout/OverlayLoading";

export default {
  name: "App",
  components: {
    Notification,
    OverlayLoading,
  },

  data: () => ({
    isOnline: true,
    isMobile: false,
    wasPressed: false,
  }),
  mounted: function () {
    const vm = this;
    window.addEventListener("load", function () {
      vm.updateOnlineStatus();
      window.addEventListener("online", vm.updateOnlineStatus);
      window.addEventListener("offline", vm.updateOnlineStatus);
    });
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
  },
  methods: {
    handlerBeforeUnload: function () {
      if (
        this.wasPressed ||
        performance.navigation.type === performance.navigation.TYPE_RELOAD
      ) {
        return;
      }
    },
    updateOnlineStatus: function () {
      if (navigator.onLine) {
        if (!this.isOnline) {
          this.isOnline = true;
          window.location.reload();
        }
      } else {
        this.isOnline = false;
        vm.$store.commit(SET_NOTIFICATION, {
          color: "error",
          message: i18n.t("msg.noInternet"),
          timeout: -1,
        });
      }
    },
    onResize: function () {
      this.isMobile = window.innerWidth < 770;
    },
    f5key() {
      let e = window.event;
      if ("F5" === e.code) {
        this.wasPressed = true;
      }
    },
  },
  beforeDestroy: function () {
    window.removeEventListener("online", this.updateOnlineStatus);
    window.removeEventListener("offline", this.updateOnlineStatus);
  },
  created() {
    document.onkeydown = this.f5key;
    document.onkeypress = this.f5key;
    document.onkeyup = this.f5key;
    document.addEventListener("onbeforeunload", this.handlerBeforeUnload());
  },
};
</script>
